// language=HTML
const template = `
    <article class="users">
        <md-content>
            <h1 class="md-display-2 section-title">Users</h1>

            <installation-breadcrumbs></installation-breadcrumbs>

            <md-card class="app-list-card" ng-if="installation.hasAdminUser">
                <app-loading ng-if="loading"></app-loading>

                <md-list ng-if="!loading">
                    <md-list-item ng-repeat="user in users" class="md-2-line">
                        <md-icon class="md-avatar-icon">person</md-icon>

                        <div class="md-list-item-text" layout="column">
                            <h3>{{ user.name }}</h3>
                            <h4>{{ user.email }}</h4>
                        </div>
                    </md-list-item>
                </md-list>
            </md-card>

            <form name="form"
                  ng-submit="createUser()"
                  ng-disabled="creating"
                  autocomplete="off">

                <md-card class="app-form-card">
                    <md-card-title>
                        <h2>Create an admin account</h2>
                    </md-card-title>

                    <md-card-content>

                        <div class="form-row">
                            <app-input-text class="flex-10"
                                            form="form"
                                            name="title"
                                            label="Title"
                                            value="newUser.person.data.title">
                            </app-input-text>

                            <app-input-text class="flex"
                                            form="form"
                                            name="first_name"
                                            label="First Name"
                                            value="newUser.person.data.first_name"
                                            required>
                            </app-input-text>

                            <app-input-text class="flex"
                                            form="form"
                                            name="last_name"
                                            label="Last Name"
                                            value="newUser.person.data.last_name"
                                            required>
                            </app-input-text>
                        </div>

                        <app-input-email form="form"
                                         name="email"
                                         label="Email address"
                                         value="newUser.email"
                                         required>
                        </app-input-email>

                        <app-input-password-confirmation
                            form="form"
                            name="password"
                            label="password"
                            value="newUser.password"
                            value-confirmation="newUser.password_confirmation"
                            required>
                        </app-input-password-confirmation>
                    </md-card-content>

                    <md-card-actions>
                        <md-button type="submit"
                                   class="md-raised md-primary"
                                   ng-disabled="form.$invalid">
                            Create user
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </md-content>
    </article>
`;

UsersController.$inject = [
    '$app',
    '$errorHandler',
    '$http',
    '$installation',
    '$scope',
    '$state',
    '$util',
    '$userFetcher',
];

function UsersController($app, $errorHandler, $http, $installation, $scope, $state, $util, $userFetcher) {
    $scope.installation = $installation;

    // Scope properties
    $scope.creating = false;
    $scope.loading = false;
    $scope.newUser = {
        title: null,
        first_name: null,
        initials: null,
        last_name: null,
        email: null,
        password: null,
        password_confirmation: null,
        person_id: null,
    };
    $scope.users = [];

    // Scope methods
    $scope.createUser = createUser;

    // Do stuff
    fetchUsers();

    // Function declarations

    /**
     * Create the user
     * @return {void}
     */
    function createUser() {
        if (!$installation.hasAdminUser) {
            createFirstUser();
            return;
        }

        const attributes = angular.copy($scope.newUser);

        attributes.roles = {
            data: [{ id: 'admin' }],
        };

        $scope.creating = true;
        const toast = $app.progressToast('Creating user');

        $userFetcher.create(attributes).then(
            response => {
                const user = response.data;

                $scope.users.push(user);

                $scope.newUser = {};
                $scope.form.$setPristine();
                $scope.form.$setUntouched();

                $scope.creating = false;

                toast.hide();
            },
            error => {
                $errorHandler.handle(error, $scope.form);

                $scope.creating = false;

                toast.hide();
            },
        );
    }

    function createFirstUser() {
        $scope.creating = true;

        const toast = $app.progressToast('Creating user');

        $http
            .post('/install/create-user', $scope.newUser, {
                headers: {
                    'X-Installation-Token': $installation.token,
                },
            })
            .then(
                response => {
                    const user = response.data.data;

                    if (user.id) {
                        $app.successToast('User created');
                        $installation.loggedIn = true;
                        $installation.hasAdminUser = true;

                        $state.go($installation.nextStep);
                    }

                    $scope.creating = false;

                    toast.hide();
                },
                error => {
                    $errorHandler.handle(error, $scope.form);

                    $scope.creating = false;

                    toast.hide();
                },
            );
    }

    function fetchUsers() {
        if (!$installation.loggedIn) {
            return;
        }

        $scope.loading = true;

        $userFetcher
            .all({ is_admin: true })
            .then(
                response => {
                    $scope.users = response.data;
                },
                error => {
                    $errorHandler.handle(error);
                },
            )
            .finally(() => {
                $scope.loading = false;
            });
    }
}

export { template, UsersController as controller };
